// extracted by mini-css-extract-plugin
module.exports = {"product-recipes":"_2JXlnk","product-recipes__title":"_1U9iMC","product-recipes__swiper":"_175J-Z"};